import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const Backdrop = () => {
  return (
    <div
      id="kairos-backdrop"
      className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center"
      style={{
        paddingTop: "300px",
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        color: "white",
        zIndex: 10,
        borderRadius: "0.375rem", // Matches Bootstrap's card border-radius
      }}
    >
      <h4 className="mb-3 text-white">You have no Subscription</h4>
      <p className="text-center" style={{ maxWidth: "300px" }}>
        Please choose a subscription first.
      </p>
      <Button as={Link} to="/settings/subscription-settings" variant="primary">
        Upgrade Now
      </Button>
    </div>
  );
};

export default Backdrop;
